<template>
  <div class="tableDevOpsCom">
    <div class="timeBox">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="选择日期">
          <el-date-picker
            v-model="formInline.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            unlink-panels
            format="yyyy-MM-dd"
            value-format="timestamp"
            :picker-options="pickerOptions"
            :clearable="false"
            size="mini"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleCurrentChange(1)" size="mini"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item v-if="judgeAuthority(authority)">
          <el-button type="primary" @click="exportExcel" size="mini"
            ><i class="el-icon-download el-icon--left"></i>
            EXCEL
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <div class="tableCom">
        <AlarmTableCom
          v-if="activeName == '告警'"
          :tabHead="tabHead"
          :tableData="tableData"
        />
        <TableCom
          v-else
          :activeName="activeName"
          :tabHead="tabHead"
          :tableData="tableData"
        />
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 30, 50, 100]"
        :page-size="page.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
        style="margin-top: 10px; text-align: right"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import AlarmTableCom from "@/components/AlarmTableCom";
import TableCom from "./TableCom";
import {
  dateFtt,
  matchingOrderLevel,
  matchingOrderStatus,
  matchingAlarmLevel,
  formatTime,
  judgeAuthority,
  exportExcelFun,
} from "@/assets/js/utils";
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";
import api from "@/api";
export default {
  props: {
    activeName: {
      type: String,
      default: "",
    },
    system: {
      type: String,
      default: "",
    },
    assetId: {
      type: String,
      default: "",
    },
  },
  components: {
    AlarmTableCom,
    TableCom,
  },
  data() {
    return {
      authority: "",
      formInline: {
        time: [],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      tabHead: [],
      tableData: [],
      currentPage: 1,
      page: {
        total: null,
        size: 10,
      },
      timeData: [],
    };
  },
  watch: {
    activeName: {
      handler(newvalue, oldvalue) {
        this.handleClick();
      },
      deep: true,
      immediate: true,
    },
    assetId: {
      handler() {
        this.handleClick();
      },
      deep: true,
    },
  },
  methods: {
    judgeAuthority,
    setTimeData() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      this.formInline.time = [start.getTime(), end.getTime()];
    },
    handleTimeData() {
      this.timeData[1] = new Date(
        dateFtt("yyyy-MM-dd 23:59:59", new Date(this.formInline.time[1]))
      ).getTime();
      this.timeData[0] = new Date(
        dateFtt("yyyy-MM-dd 00:00:00", new Date(this.formInline.time[0]))
      ).getTime();
    },
    handleClick() {
      this.$store.commit("SET_LOADING", true);
      this.setTimeData();
      this.handleTimeData();
      this.tabHead = [];
      this.tableData = [];
      this.currentPage = 1;
      this.page.size = 10;
      if (this.activeName == "工单") {
        this.tabHead = [
          { label: "工单ID", prop: "id" },
          { label: "创建时间", prop: "time" },
          { label: "工单名称", prop: "description" },
          { label: "工单级别", prop: "level" },
          { label: "工单描述", prop: "remark" },
          { label: "状态", prop: "state" },
          { label: "处理人", prop: "handleUser" },
          { label: "处理时长", prop: "takeTime" },
        ];
        this.getWorksheetsTable();
      } else if (this.activeName == "告警") {
        this.tabHead = [
          { label: "ID", prop: "alarmId" },
          { label: "报警时间", prop: "alarmEndTime" },
          { label: "设备名称", prop: "deviceName" },
          { label: "设备/区域地址", prop: "location" },
          { label: "报警类型", prop: "type" },
          { label: "报警条件", prop: "condition" },
          { label: "当前状态", prop: "status" },
          { label: "正常范围", prop: "range" },
          { label: "确认状态", prop: "handleState" },
          { label: "报警级别", prop: "alarmSeverity" },
        ];
        this.getAlarmsList();
      } else if (this.activeName == "巡检" || this.activeName == "保养") {
        if (this.activeName == "巡检") {
          this.tabHead = [
            { label: "巡检计划", prop: "plan" },
            { label: "巡检路线", prop: "route" },
            { label: "计划巡检时间", prop: "planTime" },
            { label: "巡检打卡时间", prop: "clockTime" },
            { label: "巡检点位", prop: "point" },
            { label: "巡检人", prop: "planUser" },
          ];
        } else if (this.activeName == "保养") {
          this.tabHead = [
            { label: "保养计划", prop: "plan" },
            { label: "计划保养时间", prop: "planTime" },
            { label: "保养打卡时间", prop: "clockTime" },
            { label: "保养人", prop: "planUser" },
          ];
        }
        this.getPatrolTable();
      }
    },
    handleFun() {
      this.$store.commit("SET_LOADING", true);
      this.handleTimeData();
      this.tableData = [];
      if (this.activeName == "巡检" || this.activeName == "保养") {
        this.getPatrolTable();
      } else if (this.activeName == "工单") {
        this.getWorksheetsTable();
      } else {
        this.getAlarmsList();
      }
      setTimeout(() => {
        this.$store.commit("SET_LOADING", false);
      }, 800);
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.currentPage = 1;
      this.handleFun();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.handleFun();
    },
    exportExcel() {
      exportFile.xlsxFile(XLSX, this.activeName + "记录", {
        excel: exportExcelFun(this.tabHead, this.tableData),
      });
    },

    /************ 巡检记录 ***********/
    async getPatrolTable() {
      let res = await api.devOpsPatrolTable({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        startTime: this.timeData[0],
        endTime: this.timeData[1],
        pageSize: this.page.size,
        page: this.currentPage - 1,
        deviceType: this.system,
        assetId: this.assetId,
        sourceType: this.activeName == "巡检" ? "INSPECTION" : "MAINTENANCE",
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.page.total = res.data.data.totalElements;
        this.tableData = res.data.data.data;
        this.tableData.map((v) => {
          v.planTime = `${dateFtt(
            "yyyy-MM-dd hh:mm:ss",
            new Date(v.startts)
          )}-${dateFtt("yyyy-MM-dd hh:mm:ss", new Date(v.endts))}`;
          v.clockTime =
            v.actts && v.actts != 0
              ? dateFtt("yyyy-MM-dd hh:mm:ss", new Date(v.actts))
              : "-";
          v.planUser =
            v.staffinfo && v.staffinfo != "null"
              ? JSON.parse(v.staffinfo)
                  .map((v) => {
                    return v.name;
                  })
                  .join(",")
              : "-";
        });
      }
    },
    /************ 工单记录 ***********/
    async getWorksheetsTable() {
      let res = await api.devOpsWorksheetsTable({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        startTime: this.timeData[0],
        endTime: this.timeData[1],
        pageSize: this.page.size,
        page: this.currentPage - 1,
        deviceType: this.system,
        assetId: this.assetId,
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.page.total = res.data.data.totalElements;
        this.tableData = res.data.data.data;
        this.tableData.map((v) => {
          v.time = dateFtt("yyyy-MM-dd hh:mm:ss", new Date(v.createdts));
          v.level = matchingOrderLevel(v.priority);
          v.state = matchingOrderStatus(v.status);
          v.handleUser =
            v.staffinfo && v.staffinfo != "null"
              ? JSON.parse(v.staffinfo)
                  .map((v) => {
                    return v.name;
                  })
                  .join(",")
              : "-";
          v.takeTime = v.handlets
            ? formatTime(v.handlets)
            : formatTime(new Date().getTime() - v.createdts);
        });
      }
    },
    /************ 告警记录 ***********/
    async getAlarmsList() {
      let res = await api.getSAlarmsList({
        page: this.currentPage - 1,
        pageSize: this.page.size,
        beginTs: this.timeData[0],
        endTs: this.timeData[1],
        assetId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        deviceType: this.system,
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.page.total = res.data.data.totalElements;
        this.tableData = res.data.data.data;
        this.tableData.map((v) => {
          v.alarmEndTime = dateFtt("yyyy-MM-dd hh:mm:ss", new Date(v.endTime));
          v.handleState = v.confirm ? "已确认" : "未确认";
          v.alarmSeverity = matchingAlarmLevel(v.level);
        });
      }
    },
    /************ 保洁记录 ***********/
    /************ 保养记录 ***********/
  },
  created() {
    if (this.$route.path == "/photovoltaicDevOps") {
      this.authority = "zixitong:guangfu:photovoltaicDevOps:export";
    }
    this.setTimeData();
  },
};
</script>

<style lang="scss" scoped>
.tableDevOpsCom {
  width: 98%;
  height: 100%;
  margin: 0 auto;
  .timeBox {
    width: 100%;
    height: 50px;
  }
  .table {
    width: 100%;
    height: calc(100% - 50px);
    .tableCom {
      width: 100%;
      height: 90%;
    }
  }
}
</style>
